/**
 * @generated SignedSource<<936003e15e145d17e9a916b6cc85619f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectListPage_viewer$data = {
  readonly id: string;
  readonly backendId: number | null;
  readonly firstName: string | null;
  readonly actualPersonId: string | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly client: {
    readonly id: string;
  } | null;
  readonly filters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly section: FILTER_SECTION | null;
        readonly value: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly company: {
    readonly currency: string | null;
    readonly xeroEnabled: boolean | null;
    readonly sageIntacctConnectionEnabled: boolean | null;
    readonly sageIntacctTimeRegsFromForecast: boolean | null;
    readonly priorityLevels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly projectGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly companyProjectGroupId: number | null;
        readonly name: string | null;
        readonly color: string | null;
        readonly projects: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly status: PROJECT_STATUS | null;
              readonly name: string | null;
              readonly budgetType: BUDGET_TYPE | null;
              readonly isInProjectGroup: boolean | null;
              readonly readOnlyAccess: boolean | null;
              readonly description: string | null;
              readonly projectStartDay: number | null;
              readonly projectStartMonth: number | null;
              readonly projectStartYear: number | null;
              readonly projectEndDay: number | null;
              readonly projectEndMonth: number | null;
              readonly projectEndYear: number | null;
              readonly companyProjectId: number | null;
              readonly customProjectId: string | null;
              readonly client: {
                readonly id: string;
                readonly name: string | null;
                readonly logoId: string | null;
                readonly logoDefaultId: number | null;
              } | null;
              readonly rateCard: {
                readonly id: string;
                readonly name: string | null;
                readonly currency: string | null;
                readonly parentRateCardId: string | null;
              } | null;
              readonly projectLabels: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly label: {
                      readonly id: string;
                      readonly name: string | null;
                      readonly color: string | null;
                    } | null;
                    readonly id: string;
                  } | null;
                } | null> | null;
              } | null;
              readonly projectColor: string | null;
              readonly currentProjectStatus: {
                readonly id: string;
                readonly color: string | null;
                readonly person: {
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly id: string;
                } | null;
              } | null;
              readonly priorityLevel: {
                readonly id: string;
                readonly name: string | null;
                readonly weight: number | null;
              } | null;
              readonly projectPersons: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                    readonly isContactPerson: boolean | null;
                    readonly person: {
                      readonly id: string;
                      readonly firstName: string | null;
                      readonly lastName: string | null;
                      readonly profilePictureId: string | null;
                      readonly profilePictureDefaultId: number | null;
                      readonly initials: string | null;
                    } | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly statusColor: string | null;
              readonly budget: number | null;
              readonly budgetBaseCurrency: number | null;
              readonly estimationUnit: string | null;
              readonly minutesPerEstimationPoint: number | null;
              readonly baselineWinChance: number | null;
              readonly sprintTimeBox: boolean | null;
              readonly progress: number | null;
              readonly manualProgressOnProjectEnabled: boolean | null;
              readonly manualProgressOnPhasesEnabled: boolean | null;
              readonly manualProgressOnTasksEnabled: boolean | null;
              readonly financialNumbers?: {
                readonly billablePlannedTimeAndExpenses: number | null;
                readonly actualRevenue: number | null;
                readonly remainingRevenue: number | null;
                readonly forecastRevenue: number | null;
                readonly recognitionOpenRevenue: number | null;
                readonly recognitionForecastRevenue: number | null;
                readonly recognitionLockedRevenue: number | null;
                readonly plannedCost: number | null;
                readonly actualCost: number | null;
                readonly forecastCost: number | null;
                readonly remainingCost: number | null;
                readonly plannedProfit: number | null;
                readonly forecastProfit: number | null;
                readonly invoiced: number | null;
                readonly paid: number | null;
              } | null;
              readonly financialNumbersProjectCurrency?: {
                readonly billablePlannedTimeAndExpenses: number | null;
                readonly actualRevenue: number | null;
                readonly remainingRevenue: number | null;
                readonly forecastRevenue: number | null;
                readonly recognitionOpenRevenue: number | null;
                readonly recognitionForecastRevenue: number | null;
                readonly recognitionLockedRevenue: number | null;
                readonly plannedCost: number | null;
                readonly actualCost: number | null;
                readonly forecastCost: number | null;
                readonly remainingCost: number | null;
                readonly plannedProfit: number | null;
                readonly forecastProfit: number | null;
                readonly invoiced: number | null;
                readonly paid: number | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly budgetType: BUDGET_TYPE | null;
        readonly status: PROJECT_STATUS | null;
        readonly description: string | null;
        readonly statusColor: string | null;
        readonly companyProjectId: number | null;
        readonly readOnlyAccess: boolean | null;
        readonly budget: number | null;
        readonly budgetBaseCurrency: number | null;
        readonly projectColor: string | null;
        readonly estimationUnit: string | null;
        readonly minutesPerEstimationPoint: number | null;
        readonly projectStartDay: number | null;
        readonly projectStartMonth: number | null;
        readonly projectStartYear: number | null;
        readonly projectEndDay: number | null;
        readonly projectEndMonth: number | null;
        readonly projectEndYear: number | null;
        readonly baselineWinChance: number | null;
        readonly sprintTimeBox: boolean | null;
        readonly currentProjectStatus: {
          readonly id: string;
          readonly color: string | null;
          readonly person: {
            readonly id: string;
            readonly firstName: string | null;
            readonly lastName: string | null;
          } | null;
        } | null;
        readonly client: {
          readonly id: string;
          readonly name: string | null;
          readonly logoId: string | null;
          readonly logoDefaultId: number | null;
        } | null;
        readonly rateCard: {
          readonly id: string;
          readonly name: string | null;
          readonly currency: string | null;
          readonly parentRateCardId: string | null;
        } | null;
        readonly progress: number | null;
        readonly manualProgressOnProjectEnabled: boolean | null;
        readonly manualProgressOnPhasesEnabled: boolean | null;
        readonly manualProgressOnTasksEnabled: boolean | null;
        readonly priorityLevel: {
          readonly id: string;
          readonly name: string | null;
          readonly weight: number | null;
        } | null;
        readonly projectLabels: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly label: {
                readonly id: string;
                readonly name: string | null;
                readonly color: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly projectPersons: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly isContactPerson: boolean | null;
              readonly person: {
                readonly id: string;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly profilePictureId: string | null;
                readonly profilePictureDefaultId: number | null;
                readonly initials: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
        readonly financialNumbers?: {
          readonly billablePlannedTimeAndExpenses: number | null;
          readonly actualRevenue: number | null;
          readonly remainingRevenue: number | null;
          readonly forecastRevenue: number | null;
          readonly recognitionOpenRevenue: number | null;
          readonly recognitionForecastRevenue: number | null;
          readonly recognitionLockedRevenue: number | null;
          readonly plannedCost: number | null;
          readonly actualCost: number | null;
          readonly forecastCost: number | null;
          readonly remainingCost: number | null;
          readonly plannedProfit: number | null;
          readonly forecastProfit: number | null;
          readonly invoiced: number | null;
          readonly paid: number | null;
        } | null;
        readonly financialNumbersProjectCurrency?: {
          readonly billablePlannedTimeAndExpenses: number | null;
          readonly actualRevenue: number | null;
          readonly remainingRevenue: number | null;
          readonly forecastRevenue: number | null;
          readonly recognitionOpenRevenue: number | null;
          readonly recognitionForecastRevenue: number | null;
          readonly recognitionLockedRevenue: number | null;
          readonly plannedCost: number | null;
          readonly actualCost: number | null;
          readonly forecastCost: number | null;
          readonly remainingCost: number | null;
          readonly plannedProfit: number | null;
          readonly forecastProfit: number | null;
          readonly invoiced: number | null;
          readonly paid: number | null;
        } | null;
        readonly isInProjectGroup: boolean | null;
        readonly customProjectId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ProjectListPage_viewer";
};
export type ProjectListPage_viewer$key = {
  readonly " $data"?: ProjectListPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectListPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnlyAccess",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoDefaultId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v3/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentRateCardId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v3/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "PriorityLevel",
  "kind": "LinkedField",
  "name": "priorityLevel",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weight",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "contactsOnly",
      "value": true
    },
    (v9/*: any*/)
  ],
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isContactPerson",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v28/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureDefaultId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "initials",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetBaseCurrency",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineWinChance",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v42 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billablePlannedTimeAndExpenses",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionOpenRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionForecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionLockedRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingCost",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastProfit",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "invoiced",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "paid",
    "storageKey": null
  }
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "financialNumbers",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = {
  "condition": "loadMultiCurrency",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbersProjectCurrency",
      "plural": false,
      "selections": (v42/*: any*/),
      "storageKey": null
    }
  ]
},
v45 = {
  "condition": "loadSingleCurrency",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v43/*: any*/)
  ]
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeDoneOrHalted"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeGroupProjectsFromProjectConnection"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "loadMultiCurrency"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "loadSingleCurrency"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "filters"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectGroups"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projects"
        ]
      }
    ]
  },
  "name": "ProjectListPage_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Client",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": "filters",
      "args": null,
      "concreteType": "FilterTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_filters_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilterTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Filter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "section",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "xeroEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctConnectionEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctTimeRegsFromForecast",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PriorityLevelTypeConnection",
          "kind": "LinkedField",
          "name": "priorityLevels",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PriorityLevelTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PriorityLevel",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "projectGroups",
      "args": null,
      "concreteType": "ProjectGroupTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_projectGroups_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectGroupTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectGroupType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyProjectGroupId",
                  "storageKey": null
                },
                (v3/*: any*/),
                (v8/*: any*/),
                {
                  "alias": null,
                  "args": [
                    (v9/*: any*/)
                  ],
                  "concreteType": "ProjectTypeConnection",
                  "kind": "LinkedField",
                  "name": "projects",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectTypeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectType",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v10/*: any*/),
                            (v3/*: any*/),
                            (v11/*: any*/),
                            (v12/*: any*/),
                            (v13/*: any*/),
                            (v14/*: any*/),
                            (v15/*: any*/),
                            (v16/*: any*/),
                            (v17/*: any*/),
                            (v18/*: any*/),
                            (v19/*: any*/),
                            (v20/*: any*/),
                            (v21/*: any*/),
                            (v22/*: any*/),
                            (v23/*: any*/),
                            (v24/*: any*/),
                            {
                              "alias": null,
                              "args": (v25/*: any*/),
                              "concreteType": "ProjectLabelTypeConnection",
                              "kind": "LinkedField",
                              "name": "projectLabels",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ProjectLabelTypeEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "ProjectLabel",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        (v26/*: any*/),
                                        (v0/*: any*/)
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": "projectLabels(first:10000)"
                            },
                            (v27/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProjectStatus",
                              "kind": "LinkedField",
                              "name": "currentProjectStatus",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                (v8/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "person",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v28/*: any*/),
                                    (v0/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            (v29/*: any*/),
                            (v30/*: any*/),
                            (v31/*: any*/),
                            (v32/*: any*/),
                            (v33/*: any*/),
                            (v34/*: any*/),
                            (v35/*: any*/),
                            (v36/*: any*/),
                            (v37/*: any*/),
                            (v38/*: any*/),
                            (v39/*: any*/),
                            (v40/*: any*/),
                            (v41/*: any*/),
                            (v44/*: any*/),
                            (v45/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "projects(first:1000000)"
                },
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "projects",
      "args": null,
      "concreteType": "ProjectTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_projects_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v11/*: any*/),
                (v10/*: any*/),
                (v14/*: any*/),
                (v31/*: any*/),
                (v21/*: any*/),
                (v13/*: any*/),
                (v32/*: any*/),
                (v33/*: any*/),
                (v27/*: any*/),
                (v34/*: any*/),
                (v35/*: any*/),
                (v15/*: any*/),
                (v16/*: any*/),
                (v17/*: any*/),
                (v18/*: any*/),
                (v19/*: any*/),
                (v20/*: any*/),
                (v36/*: any*/),
                (v37/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectStatus",
                  "kind": "LinkedField",
                  "name": "currentProjectStatus",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v8/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v28/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v23/*: any*/),
                (v24/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/),
                (v40/*: any*/),
                (v41/*: any*/),
                (v29/*: any*/),
                {
                  "alias": null,
                  "args": (v25/*: any*/),
                  "concreteType": "ProjectLabelTypeConnection",
                  "kind": "LinkedField",
                  "name": "projectLabels",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectLabelTypeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectLabel",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v26/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "projectLabels(first:10000)"
                },
                (v30/*: any*/),
                (v44/*: any*/),
                (v45/*: any*/),
                (v12/*: any*/),
                (v22/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "387ed5ae853a971ea555e09b78faf6d7";

export default node;
